export const IDP_NAME_REGEX = /^[A-Za-z0-9.:/-]{3,32}$/;
export const DEFAULT_EMAIL_ATTRIBUTE_NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';

export enum DomainSuffix {
  PRD = '.cloud.tanium.com',
  STG = '.cloud.tan-stage.com',
  DEV = '.dev.cloud.tan-stage.com',
}

const baseDocs = 'https://help.tanium.com/bundle/ug_tanium_account/page/tanium_account';
export const DocLinks = {
  DOCS_HOME: `${baseDocs}/index.html`,
  GETTING_STARTED: `${baseDocs}/getting_started.html`,
  CONFIG_AD_FS: `${baseDocs}/configuring_AD_FS.html`,
  CONFIG_AZURE: `${baseDocs}/configuring_entra_id.html`,
  CONFIG_GOOGLE: `${baseDocs}/configuring_google.html`,
  CONFIG_OKTA: `${baseDocs}/configuring_okta.html`,
  CONFIG_ORACLE: `${baseDocs}/configuring_oracle_identity_cloud.html`,
  CONFIG_PING: `${baseDocs}/configuring_pingfederate.html`,
  CONFIG_SF: `${baseDocs}/configuring_salesforce.html`,
  VERIFY_DOMAIN: `${baseDocs}/add_domains.html`,
  IDP_ROLE_ASSIGN: `${baseDocs}/configuring_identity_providers_account.html`,
};

export const DataRegions = {
  US_E1: 'us-e1',
  EU_N1: 'eu-n1',
  JP_E1: 'jp-e1',
  CA_C1: 'ca-c1',
  UK_S1: 'uk-s1',
  AU_E1: 'au-e1',
  SA_E1: 'sa-e1',
};

export const getRegionDisplayName = (region: string | undefined): string => {
  switch (region) {
    case DataRegions.US_E1:
      return 'United States';
    case DataRegions.EU_N1:
      return 'European Union';
    case DataRegions.JP_E1:
      return 'Japan';
    case DataRegions.CA_C1:
      return 'Canada';
    case DataRegions.UK_S1:
      return 'United Kingdom';
    case DataRegions.AU_E1:
      return 'Australia';
    case DataRegions.SA_E1:
      return 'South America';
  }
  return 'Unknown';
};
